module.exports = __webpack_public_path__ + "media/images/landing/icon-helping-a-partner-6836aaf81201aeeb726b121058db21b5.svg";